import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddAlert, Button, Modal } from '../../../../component';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { refetchData } from '../../polygons/redux/polygonsActions';
import { deletePolygons } from '../../polygons/redux/polygonsInfra';
import { modalOpen } from '../../redux/dashboardActions';

export const DeletePolygonsModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../nls/${preference.language.id}.json`);
  const { statusModal } = useSelector((state: any) => state.layoutState);
  const { name, id } = useSelector(
    (state: any) => state.polygonsState.switches.toDelete
  );

  const handleDelete = async (
    polygonId: string,
    polygonName: string
  ): Promise<void> => {
    dispatch([modalOpen(''), loading()]);
    try {
      const response = await deletePolygons(polygonId);
      if (response.status >= 400 && response.status < 600) {
        throw new Error('Bad response from server');
      }
      dispatch([
        AddAlert(
          'success',
          `"${polygonName}"${nls.actionsMap.deletePolygons.modal.successDeleted}`
        ),
        refetchData(),
      ]);
    } catch {
      dispatch(
        AddAlert(
          'error',
          `${nls.actionsMap.deletePolygons.modal.failDeleted}"${polygonName}"`
        )
      );
    }
    dispatch(loaded());
  };
  return (
    <Modal
      title={
        <span data-cy="SavePolygonsTitle" className="delete-polygon-title">
          {`${nls.actionsMap.deletePolygons.modal.title}"${name}"`}
        </span>
      }
      open={statusModal === 'delete polygons'}
      close={() => {
        dispatch(modalOpen(''));
      }}
      closeText={nls.actionsMap.deletePolygons.modal.closeText}
      cy="DeletePolygons"
      closeBtnClasses="delete-polygon-button-close"
      actions={
        <Button
          cy="DeletePolygons"
          color="primary"
          onClick={() => {
            handleDelete(id, name);
          }}
          className="btn delete-polygons-button-action"
        >
          {nls.actionsMap.deletePolygons.modal.confirm}
        </Button>
      }
    >
      <p>{nls.actionsMap.deletePolygons.modal.irreversible}</p>
    </Modal>
  );
};
